export default class StocktakingUnconsideredMember {
    static fromData(data) {
        if (!data) {
            return;
        }

        let member = new StocktakingUnconsideredMember();
        member.id = data.id;
        member.fullname = data.fullname;
        member.membershipNumber = data.membershipNumber;
        member.gender = data.gender;
        member.dateOfBirth = data.dateOfBirth;

        Object.seal(member);
        return member;
    }
}
